module.exports = __webpack_public_path__ + "static/img/day5.07939b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rural/tour1/day5.jpg
// module id = 7kFC
// module chunks = 0